import { RichTextEditor } from "@mantine/tiptap";
import { Editor, useEditor } from "@tiptap/react";
import Link from "@tiptap/extension-link";
import Underline from "@tiptap/extension-underline";
import StarterKit from "@tiptap/starter-kit";
import { MutableRefObject } from "react";
import { Input, InputWrapperProps } from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";

interface ContentEditorProps<T> extends InputWrapperProps {
  formKey: string;
  label: string;
  form: UseFormReturnType<T>;
  required?: boolean;
  editorRef?: MutableRefObject<Editor | null>;
}

export default function ContentEditor<T>(props: ContentEditorProps<T>) {
  const {
    formKey,
    label,
    required,
    form,
    editorRef,
    ...restProps
  } = props;

  const editor = useEditor({
    extensions: [
      StarterKit,
      Underline,
      Link
    ],
  });

  if (editorRef && editor) editorRef.current = editor;
  
  return (
    <Input.Wrapper
      {...form.getInputProps(formKey)}
      key={form.key(formKey)}
      label={label}
      required={!!required}
      {...restProps}
    >
      <RichTextEditor editor={editor}>
        <RichTextEditor.Toolbar>

          <RichTextEditor.ControlsGroup>
            <RichTextEditor.Bold />
            <RichTextEditor.Italic />
            <RichTextEditor.Underline />
          </RichTextEditor.ControlsGroup>

          <RichTextEditor.ControlsGroup>
            <RichTextEditor.H1 />
            <RichTextEditor.H2 />
            <RichTextEditor.H3 />
          </RichTextEditor.ControlsGroup>

          <RichTextEditor.ControlsGroup>
            <RichTextEditor.Link />
            <RichTextEditor.Unlink />
          </RichTextEditor.ControlsGroup>

          <RichTextEditor.ControlsGroup>
            <RichTextEditor.BulletList />
            <RichTextEditor.OrderedList />
          </RichTextEditor.ControlsGroup>

        </RichTextEditor.Toolbar>

        <RichTextEditor.Content />

      </RichTextEditor>
    </Input.Wrapper>
  )
}
